import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const KEYWORD_RULE_EDITOR_CLASS_NAME = 'KeywordRuleEditor';
export const KEYWORD_RULE_EDITOR_CLASS_SLOTS = ['root'] as const;

export type KeywordRuleEditorClassSlot =
	(typeof KEYWORD_RULE_EDITOR_CLASS_SLOTS)[number];

export interface KeywordRuleEditorClasses {
	root: string;
}

export type KeywordRuleEditorClassKey = keyof KeywordRuleEditorClasses;

export const getKeywordRuleEditorUtilityClass = (slot: string) =>
	generateUtilityClass(KEYWORD_RULE_EDITOR_CLASS_NAME, slot);

export const keywordRuleEditorClasses: KeywordRuleEditorClasses =
	generateUtilityClasses(KEYWORD_RULE_EDITOR_CLASS_NAME, ['root']);

export default keywordRuleEditorClasses;
